"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getInfoBannerUtilityClass = getInfoBannerUtilityClass;
var _mui = require("@ori-ui/mui");
function getInfoBannerUtilityClass(slot) {
  return (0, _mui.generateUtilityClass)('InfoBanner', slot);
}
const infoBannerClasses = (0, _mui.generateUtilityClasses)('InfoBanner', ['root', 'content']);
var _default = exports.default = infoBannerClasses;
